import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface headerTitle {
    header: string;
    color: string;
    parentRoute: string | null;
    display: string | null | undefined;
    [key: string]: string | null | undefined; // Generic object to store data for different pages
}

const initialState: headerTitle = {
    header: '',
    color: 'var(--header-color)',
    parentRoute: null,
    display: null
};

export const headerTitleSlice = createSlice({
    name: 'headerTitle',
    initialState,
    reducers: {
        setHeaderTitle: (state: any, action: any) => {
            state.header = action.payload.header;
            state.color = action.payload.color;
            state.parentRoute = action.payload.parentRoute;
            state.display = action.payload.display ? action.payload.display : null;
        },
        setPageData: (state, action: PayloadAction<{ page: string, id: string }>) => {

            state[action.payload.page] = action.payload.id;
        },
        clearPageData: (state) => {
            Object.keys(state).forEach(key => {
                state[key] = null;
            });
        },
    },
});

// this is for dispatch
export const { setHeaderTitle, setPageData, clearPageData }: any = headerTitleSlice.actions;

// this is for configureStore
export default headerTitleSlice.reducer;
